export const ACCESS_MODEL = "access";
export const ACCESS_GROUP_MODEL = "access_group";
export const ATTACHMENT_MODEL = "attachment";
export const BRANCH_MODEL = "branch";
export const INVESTIGATION_MODEL = "investigation";
export const LOG_MODEL = "log";
export const NOTICE_MODEL = "notice";
export const NOTIFICATION_MODEL = "notifcation";
export const INVOICE_MODEL = "invoice";
export const ORDERLINE_MODEL = "orderline";
export const ORDER_MODEL = "order";
export const PRODUCT_CATEGORY_MODEL = "product_category";
export const PRODUCT_MODEL = "product";
export const USER_MODEL = "user";
export const ACCOUNTING_MODEL = "accounting";